import { Stack, Typography, Divider } from '@mui/material';
import { BackupPolicyType } from '@repo/api-gw-sdk';

import type { VaultManagedType } from '@/components/vaults/vaultManagedTypeSelect';
import { useEnvironment } from '@/contexts/useEnvironment';
import { ResourceTypes } from '@/data/inventory/resourceTypes';
import { joinByCommaWithLastAnd } from '@/utils/string';

import { isRestrictedTypesPolicy } from './BackupPolicyConditionEditor';
import { AwsByovSupportedResourceTypes } from './awsByovSupportedResourceTypes';
import { HighFrequencySupportedResourceTypes } from './highFrequencySupportedResourceTypes';
import { pitrPolicySupportedResourceTypes } from './pitrPolicySupportedResourceTypes';

export const CustomPolicySupportedDisclaimer = ({
  policyType,
  vaultManagedType,
}: {
  policyType: BackupPolicyType;
  vaultManagedType?: VaultManagedType;
}) => {
  const { isDemo } = useEnvironment();

  const text =
    policyType === BackupPolicyType.BACKUP_POLICY_TYPE_HIGH_FREQUENCY
      ? `High-frequency backup policy. Available for ${joinByCommaWithLastAnd(HighFrequencySupportedResourceTypes.map((x) => ResourceTypes[x].displayName))}.`
      : policyType === BackupPolicyType.BACKUP_POLICY_TYPE_PITR
        ? `Point-in-time recovery backup policy. Available for ${joinByCommaWithLastAnd(pitrPolicySupportedResourceTypes.map((x) => ResourceTypes[x].displayName))}.`
        : `Standard backup policy with self-managed vaults. Available for ${joinByCommaWithLastAnd(AwsByovSupportedResourceTypes.map((x) => ResourceTypes[x].displayName))}.`;

  return (
    <>
      {!isDemo && isRestrictedTypesPolicy(policyType, vaultManagedType) && (
        <Stack gap='2px'>
          <div />
          <Typography
            padding='12px 40px'
            align='center'
            className='bg-[var(--mui-palette-background-page)]'
          >
            {text}
          </Typography>
          <Divider />
        </Stack>
      )}
    </>
  );
};
